export default __webpack_public_path__ + "static/media/bg-onboarding-mobile.bb15e46b.jpg";